import { Component, Input } from '@angular/core';
import { CredentialSingletonService } from 'src/app/shared/services/credential-singleton.service';
import {
  CredentialEvidenceModel,
  IEvidenceSnapshotModel
} from 'src/app/shared/models/credential/personScenarioEvidenceDetails';

@Component({
  selector: 'evidence-snapshots',
  templateUrl: './evidence-snapshots.component.html',
  styleUrls: ['./evidence-snapshots.component.scss'],
  standalone: false
})
export class EvidenceSnapshotsComponent {
  @Input()
  credentialEvidence: CredentialEvidenceModel;
  @Input() scenarioId: string;
  @Input({ required: true })
  title: string;

  /** only needed for downloading documents after a snapshot is taken*/
  @Input()
  credentialDefinitionId: string;

  showAllFields: boolean = false;

  constructor(public credentialSingletonService: CredentialSingletonService) {}

  openEvidenceDocumentInS3 = async (fileName: string, evidence: IEvidenceSnapshotModel) => {
    //this function passed to EvidenceSnapshotComponent so can avoid passing isCompleted, and credentialDefinitionId
    await this.credentialSingletonService.openEvidenceDocumentInS3(
      fileName,
      evidence,
      this.credentialDefinitionId,
      !!this.credentialEvidence?.evidenceSnapshotTakenDate
    );
  };

  public EmptyEvidenceCount(): number {
    if (!this.credentialEvidence?.evidences?.length) return 0;

    return this.credentialEvidence.evidences.filter((e) => !e.evidenceValue?.length).length;
  }
}
